export default "__VITE_ASSET__D1d8yVh0__"